import React, {useState,useEffect} from 'react';
import useStyles from './Styles';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import FormGroup from '@mui/material/FormGroup';
import FormHelperText from '@mui/material/FormHelperText';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import Select,{SelectChangeEvent} from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import SearchIcon from '@mui/icons-material/Search';
import DeleteIcon from '@mui/icons-material/Delete';
import {Tools} from './Tools';
import {Inc,Dataset,ZaikoSearchCondition,SortOption} from './Inc';
import Title from './Title';
import AppBank from './AppBank';

interface ZaikoListSearchProps {
    update(cond:ZaikoSearchCondition,page:number): void,
	bankKey:string,
	bank:AppBank,
}

const ZaikoListSearch = (props:ZaikoListSearchProps)=> {
    const classes = useStyles();
    const [states,setStates] = useState(Inc.defaultZaikoSearchCondition());

    const update = ()=>{
		props.bank.set(props.bankKey,JSON.stringify(states));
        props.update(states,1);
    }
	const handleChange = (name: keyof ZaikoSearchCondition) => (event: React.ChangeEvent<HTMLInputElement>) => {
		setStates({ ...states, [name]: event.target.value });
    };
	const handleChangeNumber = (name: keyof ZaikoSearchCondition) => (event: React.ChangeEvent<HTMLInputElement>) => {
        setStates({ ...states, [name]: Tools.toHan(event.target.value) });
        //setStates({ ...states, [name]: event.target.value });
	};    
	const handleChangeSelect = (name: keyof ZaikoSearchCondition) => (event: SelectChangeEvent) => {
		setStates({ ...states, [name]: event.target.value });
    };
	const handleChangeOption = (name: keyof SortOption) => (event: SelectChangeEvent) => {
        let option = states.option;
        option[name] = event.target.value;
		setStates({ ...states, "option": option});
    };
	const handleChangeCheckboxes = (name: keyof ZaikoSearchCondition,index:number) => (event: React.ChangeEvent<HTMLInputElement>) => {
		let boolList:boolean[] = [];
		let idList:string[] = [];
		let blName:string = "";
		let datas:Dataset[] = [];
		if( name==="sample_ids" ){
			boolList = states.sample_bls;
			blName = "sample_bls";
			datas = Inc.exists;
		}
		if( name==="stock_ids" ){
			boolList = states.stock_bls;
			blName = "stock_bls";
			datas = Inc.exists;
		}

        if( blName!=="" ){
			if( event.target.checked ){
				boolList[index] = true;
			} else {
				boolList[index] = false;
			}
			for( let i=0 ; i<boolList.length ; i++ ){
				if( boolList[i] ){
					idList.push( datas[i].id );
				}
			}
			setStates({ ...states, [blName]: boolList, [name]: idList });
		}
	};
	const resetCondition = ()=>{
		setStates(Inc.defaultZaikoSearchCondition());
	}
    
	const checkboxes = (id:keyof ZaikoSearchCondition,list:Dataset[])=>{
		const tmp = list.map( (data:Dataset,index:number)=>{
			const key = id+index;
			let v:boolean = false;
			if( id==="sample_ids" ){
				v = states.sample_bls[index];
			}
			if( id==="stock_ids" ){
				v = states.stock_bls[index];
			}
			return (
				<FormControlLabel
			    	key={key}
					control={
					<Checkbox
						checked={v}
						onChange={handleChangeCheckboxes(id,index)}
						value={String(data.id)}
						color="primary"
						className={classes.checkbox}
					/>
					}
					label={data.label}
				/>
			);
		});
		return (
			<div className={classes.checkboxes}>
				{tmp}
			</div>
		)
    };

    useEffect( ()=>{
		if( props.bank.has(props.bankKey) ){
			//console.log("load");
			const cond = JSON.parse(props.bank.get(props.bankKey));
			setStates(cond);
			props.update(cond,1);
		} else {
			props.update(states,1);
		}
    },[])
    
    //const years = Tools.getSelectYears();
    //const months = Tools.getSelectMonths();
    const orders:Dataset[] = [
        {
            id:"item_id",
            label:"商品ID",
        },
        {
            id:"item_name",
            label:"商品名",
        },
    ]

    //console.log("stock::list::search");

    let error = false;
    if( states.item_id!=="" && !Tools.isNumber(states.item_id) ){
        error = true;
    }

	return (
		<div id="stock_list_search">
            
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <Title text="検索条件" size={2}/>
                </Grid>
                <Grid item xs={6}>
                    <div className={classes.searchButtons}>
                        <Button variant="outlined" color="primary" onClick={update} disabled={error}><SearchIcon/>検索</Button>
                    </div>
                </Grid>
                <Grid item xs={6} md={12}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <FormLabel component="label" className={classes.formLabel}>商品名</FormLabel>
                        <TextField
                            className={classes.input}
                            inputProps={{
                                'aria-label': 'Description',
                            }}
                            margin="none"
                            value={states.item_name}
							variant="standard"
                            onChange={handleChange("item_name")}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={6} md={12}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <FormLabel component="label" className={classes.formLabel}>商品ID</FormLabel>
                        <TextField
                            className={classes.input}
                            inputProps={{
                                'aria-label': 'Description',
                            }}
                            margin="none"
                            value={states.item_id}
							variant="standard"
                            onChange={handleChangeNumber("item_id")}
                        />
                        {error &&
                        <FormHelperText>数字で入力して下さい</FormHelperText>
                        }
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={12}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <FormLabel component="label" className={classes.formLabel}>状態表示</FormLabel>
                        
                        <Select
                            value={states.status}
                            onChange={handleChangeSelect('status')}
                            inputProps={{
                                name: 'status',
                                id: 'status-simple',
                            }}
                            margin="none"
							variant="standard"
                            className={classes.select}
                        >
                            <MenuItem key="status0" value="">　</MenuItem>
                            {Inc.itemStatus.map((option:Dataset,index:number) => {
                                const key = "status"+index;
                                return (
                                    <MenuItem key={key} value={option.id}>
                                        {option.label}
                                    </MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={12}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <FormLabel component="label" className={classes.formLabel}>在庫の有無</FormLabel>
                        <FormGroup>
                            {checkboxes("stock_ids",Inc.exists)}
                        </FormGroup>
                    </FormControl>
                </Grid>


                <Grid item xs={4} md={6} lg={6}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <FormLabel component="label" className={classes.formLabel}>表示基準</FormLabel>
                        
                        <Select
                            value={states.option.order}
                            onChange={handleChangeOption('order')}
                            inputProps={{
                                name: 'order',
                                id: 'order-simple',
                            }}
                            margin="none"
							variant="standard"
                            className={classes.select}
                        >
                            {orders.map((option:Dataset,index:number) => {
                                const key = "order"+index;
                                return (
                                    <MenuItem key={key} value={option.id}>
                                        {option.label}
                                    </MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={4} md={6} lg={6}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <FormLabel component="label" className={classes.formLabel}>表示順</FormLabel>
                        
                        <Select
                            value={states.option.sort}
                            onChange={handleChangeOption('sort')}
                            inputProps={{
                                name: 'sort',
                                id: 'sort-simple',
                            }}
                            margin="none"
							variant="standard"
                            className={classes.select}
                        >
                            {Inc.sorts.map((option:Dataset,index:number) => {
                                const key = "sort"+index;
                                return (
                                    <MenuItem key={key} value={option.id}>
                                        {option.label}
                                    </MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={4} md={12} lg={12}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <FormLabel component="label" className={classes.formLabel}>表示件数</FormLabel>
                        
                        <Select
                            value={states.option.per_page}
                            onChange={handleChangeOption('per_page')}
                            inputProps={{
                                name: 'per_page',
                                id: 'per_page-simple',
                            }}
                            margin="none"
							variant="standard"
                            className={classes.select}
                        >
                            {Inc.perPages.map((option:Dataset,index:number) => {
                                const key = "per_page"+index;
                                return (
                                    <MenuItem key={key} value={option.id}>
                                        {option.label}
                                    </MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                </Grid>

            </Grid>
            <Button variant="outlined" fullWidth={true} className={classes.buttonReset} onClick={resetCondition}><DeleteIcon/>検索条件のリセット</Button>
		</div>
	);
}

export default ZaikoListSearch;
